import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Pages
import Homepage from "@/pages/Homepage";
import FiveKGuarantee from "@/pages/FiveKGuarantee";
import PTGrowthAcademy from "@/pages/PTGrowthAcademy";
import LeadConversion from "@/pages/LeadConversion";
import ThankYou from "@/pages/ThankYou";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";

// Components
import StickyApplyCTA from "@/components/apex/StickyApplyCTA";

function App() {
  return (
    <div className="App bg-[#0A0A0A]">
      <BrowserRouter>
        <ScrollToTop />
        <StickyApplyCTA />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/5k-guarantee" element={<FiveKGuarantee />} />
          <Route path="/pt-growth-academy" element={<PTGrowthAcademy />} />
          <Route path="/lead-conversion" element={<LeadConversion />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
